export const errors = {
  // shared
  internalError: "errors.500",
  unauthorized: "errors.403",
  unauthenticated: "errors.401",
  badRequestData: "errors.400",

  // ui-specific
  schemaError: "errors.1000",

  // validation
  max50: "errors.validation.max50",
  max100: "errors.validation.max100",
  max1000: "errors.validation.max1000",
  required: "errors.validation.required",
  validationEmail: "errors.validation.email",
  validationGeneric: "errors.validation.generic",
} as const;
